import * as React from 'react';

import FileBookmark32 from './FileBookmark32';

export const fileBookmark32 = () => <FileBookmark32 />;

export default {
    title: 'Icon|Content|FileBookmark32',
    component: FileBookmark32,
    parameters: {
        notes: "`import FileBookmark32 from 'box-ui-elements/es/icon/content/FileBookmark32';`",
    },
};
